import { getJson, sendJson } from '@/lib/api';
import type { ThreadMessage } from '@bcecloud/portal-ui';
import type { NewMessage } from '@/lib/workspace';

/**
 * The event's internal thread: BCE talking to BCE. Same message shape as the
 * client thread so the one component renders both; stored apart so the
 * client's portal can never read it.
 */

const base = (eventId: string): string => `/events/${eventId}/internal-messages`;

export const listInternalMessages = (eventId: string, signal?: AbortSignal): Promise<ThreadMessage[]> =>
  getJson<ThreadMessage[]>(base(eventId), undefined, signal);

export const postInternalMessage = (eventId: string, message: NewMessage): Promise<ThreadMessage> =>
  sendJson<ThreadMessage>('post', base(eventId), message);

/** Someone who can be @-tagged on the thread: anyone who can see the event. */
export interface MentionCandidateDto {
  readonly id: string;
  readonly name: string;
  readonly role: string;
}

export const listMentionCandidates = (eventId: string, signal?: AbortSignal): Promise<MentionCandidateDto[]> =>
  getJson<MentionCandidateDto[]>(`${base(eventId)}/candidates`, undefined, signal);
